import AT from '../../actionTypes/'

export default function stagedRecord(state = {}, action) {
  const { type, payload } = action

  switch (type) {
    case AT.SET_STAGED_CREDIT_TASK: {
      return payload
    }
    default: {
      return state
    }
  }
}
